import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';

export const helperApi = createApi({
	reducerPath: 'helperApi',
	tagTypes: ['specialties', 'attendee-regions', 'attendee-specialties'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		getEventSpecialties: builder.query({
			query: () => ({
				url: `helper/specialties`,
			}),
			providesTags: ['specialties'],
		}),
		getAttendeeRegions: builder.query({
			query: () => ({
				url: `helper/attendee-regions`,
			}),
			providesTags: ['attendee-regions'],
		}),
		getAttendeeSpecialties: builder.query({
			query: () => ({
				url: `helper/attendee-specialties`,
			}),
			providesTags: ['attendee-specialties'],
		}),
	}),
});

export const { useGetEventSpecialtiesQuery, useGetAttendeeRegionsQuery, useGetAttendeeSpecialtiesQuery } = helperApi;
